(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCatalog(root, sectionIndex) {
    const cards = Array.from(root.querySelectorAll('[data-wc-card]'));
    const lightbox = root.querySelector('[data-wc-lightbox]');
    if (!cards.length || !lightbox) return;

    const image = lightbox.querySelector('[data-wc-lightbox-image]');
    const imageWrap = lightbox.querySelector('.wc-lightbox-image');
    const caption = lightbox.querySelector('[data-wc-lightbox-caption]');
    const closeButton = lightbox.querySelector('[data-wc-close]');
    const prevButton = lightbox.querySelector('[data-wc-prev]');
    const nextButton = lightbox.querySelector('[data-wc-next]');
    const zoomInButton = lightbox.querySelector('[data-wc-zoom-in]');
    const zoomOutButton = lightbox.querySelector('[data-wc-zoom-out]');
    const zoomResetButton = lightbox.querySelector('[data-wc-zoom-reset]');
    const hint = lightbox.querySelector('[data-wc-lightbox-hint]');
    const linkLabel = root.dataset.wcLinkLabel || '';
    // 縦長（スマホ）と横長（PC）でページ画像もQRの位置も違うので、リンク位置は版ごとに別に読む
    const linkSets = {
      portrait: { url: root.dataset.wcLinksUrl || '', byPage: null, request: null },
      landscape: { url: root.dataset.wcLinksLandscapeUrl || '', byPage: null, request: null },
    };
    let hotspotLayer = null;
    if (imageWrap && (linkSets.portrait.url || linkSets.landscape.url)) {
      hotspotLayer = document.createElement('div');
      hotspotLayer.className = 'wc-hotspots';
      imageWrap.appendChild(hotspotLayer);
    }
    const pages = cards.map((card) => ({
      number: Number(card.dataset.n),
      label: card.dataset.label || '',
      expanded: card.dataset.expanded || '',
      zoom: card.dataset.zoom || '',
      expandedLandscape: card.dataset.expandedLandscape || '',
      zoomLandscape: card.dataset.zoomLandscape || '',
    }));
    const landscapeQuery =
      root.dataset.wcLandscapeMedia && window.matchMedia ? window.matchMedia(root.dataset.wcLandscapeMedia) : null;

    function isLandscape() {
      return Boolean(landscapeQuery && landscapeQuery.matches);
    }

    function expandedSrc(page) {
      return (isLandscape() && page.expandedLandscape) || page.expanded;
    }

    function zoomSrc(page) {
      if (isLandscape() && page.expandedLandscape) return page.zoomLandscape;
      return page.zoom;
    }

    function currentLinks() {
      const page = pages[currentIndex];
      return isLandscape() && page && page.expandedLandscape ? linkSets.landscape : linkSets.portrait;
    }
    let currentIndex = 0;
    let lastFocus = null;
    let closeTimer = null;
    let zoom = 1;
    let panX = 0;
    let panY = 0;
    let isDragging = false;
    let didDrag = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragPanX = 0;
    let dragPanY = 0;
    const activePointers = new Map();
    let isPinching = false;
    let pinchStartDistance = 0;
    let pinchStartZoom = 1;
    let pinchStartPanX = 0;
    let pinchStartPanY = 0;
    let pinchCenterX = 0;
    let pinchCenterY = 0;
    let swipePointerId = null;
    let swipeStartX = 0;
    let swipeStartY = 0;
    let pointerStartedOnHotspot = false;
    const preloaded = new Set();
    const pendingZoomLoads = new Set();

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function clampPan() {
      if (!imageWrap || zoom <= 1) {
        panX = 0;
        panY = 0;
        return;
      }
      const maxX = Math.max(24, (imageWrap.offsetWidth * (zoom - 1)) / 2 + 24);
      const maxY = Math.max(24, (imageWrap.offsetHeight * (zoom - 1)) / 2 + 24);
      panX = clamp(panX, -maxX, maxX);
      panY = clamp(panY, -maxY, maxY);
    }

    function updateZoomUi() {
      if (zoomResetButton) zoomResetButton.textContent = Math.round(zoom * 100) + '%';
      if (zoomOutButton) zoomOutButton.disabled = zoom <= 1;
      if (zoomInButton) zoomInButton.disabled = zoom >= 2.5;
      if (imageWrap) imageWrap.classList.toggle('is-zoomed', zoom > 1);
    }

    function applyTransform() {
      clampPan();
      imageWrap.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoom + ')';
      updateZoomUi();
    }

    function loadZoomImage() {
      const page = pages[currentIndex];
      const src = page ? zoomSrc(page) : '';
      if (!src || zoom <= 1.2 || image.getAttribute('src') === src || image.src === src) return;
      if (preloaded.has(src)) {
        image.src = src;
        return;
      }
      if (pendingZoomLoads.has(src)) return;
      pendingZoomLoads.add(src);
      const targetIndex = currentIndex;
      const zoomImage = new Image();
      zoomImage.decoding = 'async';
      zoomImage.onload = function () {
        preloaded.add(src);
        pendingZoomLoads.delete(src);
        // 読み込み中に画面幅が変わって縦横が入れ替わっていたら差し替えない
        if (currentIndex === targetIndex && zoom > 1.2 && zoomSrc(pages[currentIndex]) === src) image.src = src;
      };
      zoomImage.onerror = function () {
        pendingZoomLoads.delete(src);
      };
      zoomImage.src = src;
    }

    function setZoom(value) {
      zoom = clamp(Math.round(value * 100) / 100, 1, 2.5);
      if (zoom === 1) {
        panX = 0;
        panY = 0;
      }
      loadZoomImage();
      applyTransform();
    }

    function distanceBetweenPointers() {
      const points = Array.from(activePointers.values());
      if (points.length < 2) return 0;
      return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
    }

    function centerBetweenPointers() {
      const points = Array.from(activePointers.values());
      return {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2,
      };
    }

    function startPinch() {
      isPinching = true;
      // 2本指になった操作は、指を離す順番にかかわらずページ送りにしない
      swipePointerId = null;
      isDragging = false;
      didDrag = true;
      imageWrap.classList.remove('is-dragging');
      pinchStartDistance = distanceBetweenPointers();
      pinchStartZoom = zoom;
      pinchStartPanX = panX;
      pinchStartPanY = panY;
      const center = centerBetweenPointers();
      pinchCenterX = center.x;
      pinchCenterY = center.y;
    }

    function resetZoom() {
      zoom = 1;
      panX = 0;
      panY = 0;
      applyTransform();
    }

    function animateTurn(direction) {
      if (!imageWrap || !direction) return;
      imageWrap.classList.remove('is-turning-next', 'is-turning-prev');
      void imageWrap.offsetWidth;
      imageWrap.classList.add(direction > 0 ? 'is-turning-next' : 'is-turning-prev');
    }

    function preloadPage(index) {
      const page = pages[(index + pages.length) % pages.length];
      const src = page ? expandedSrc(page) : '';
      if (!src || preloaded.has(src)) return;
      preloaded.add(src);
      const preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.src = src;
    }

    function preloadAround(index) {
      const schedule = window.requestIdleCallback || function (callback) {
        return window.setTimeout(callback, 180);
      };
      schedule(() => {
        preloadPage(index - 1);
        preloadPage(index + 1);
      });
    }

    // 商品ページへのリンク位置（PDFのQRコードの位置）。初めて拡大表示を開いたときに1回だけ読む
    function loadLinks(set) {
      if (!set.url) return Promise.resolve(null);
      if (!set.request) {
        set.request = fetch(set.url, { credentials: 'omit' })
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            set.byPage = (data && data.pages) || {};
            return set.byPage;
          })
          .catch(() => {
            set.byPage = {};
            return set.byPage;
          });
      }
      return set.request;
    }

    function renderHotspots() {
      if (!hotspotLayer) return;
      hotspotLayer.textContent = '';
      const page = pages[currentIndex];
      const byPage = currentLinks().byPage;
      const links = (page && byPage && byPage[pad(page.number)]) || [];
      links.forEach((link) => {
        if (!link || !link.url) return;
        const anchor = document.createElement('a');
        anchor.className = 'wc-hotspot';
        anchor.href = link.url;
        anchor.dataset.wcHotspot = '';
        anchor.style.left = link.x * 100 + '%';
        anchor.style.top = link.y * 100 + '%';
        anchor.style.width = link.w * 100 + '%';
        anchor.style.height = link.h * 100 + '%';
        const name = [link.code, link.title].filter(Boolean).join(' ');
        anchor.setAttribute('aria-label', name ? linkLabel + ': ' + name : linkLabel);
        anchor.draggable = false;
        hotspotLayer.appendChild(anchor);
      });
      if (hint) hint.hidden = links.length === 0;
    }

    // 戻るボタンで同じページに戻れるよう、開いているページ番号をURLに残す。
    // 同じページにカタログが複数あると取り違えるので、先頭のカタログだけが使う
    const usesHash = sectionIndex === 0;

    function rememberPage() {
      const page = pages[currentIndex];
      if (!usesHash || !page || !window.history || !window.history.replaceState) return;
      window.history.replaceState(window.history.state, '', '#p-' + pad(page.number));
    }

    function forgetPage() {
      if (!usesHash || !/^#p-\d+$/.test(window.location.hash) || !window.history || !window.history.replaceState) return;
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }

    function show(index, direction, options) {
      const shouldResetZoom = options && options.resetZoom;
      currentIndex = (index + pages.length) % pages.length;
      const page = pages[currentIndex];
      if (!page) return;
      if (shouldResetZoom) {
        resetZoom();
      } else {
        panX = 0;
        panY = 0;
      }
      animateTurn(direction);
      lightbox.classList.toggle('is-landscape', isLandscape() && Boolean(page.expandedLandscape));
      image.src = expandedSrc(page);
      image.alt = 'p.' + pad(page.number) + ' ' + page.label;
      caption.textContent = pad(page.number) + ' · ' + page.label;
      renderHotspots();
      const links = currentLinks();
      if (links.url && !links.byPage) loadLinks(links).then(renderHotspots);
      rememberPage();
      loadZoomImage();
      applyTransform();
      preloadAround(currentIndex);
    }

    function open(number) {
      const index = pages.findIndex((page) => page.number === number);
      if (index < 0) return;
      lastFocus = document.activeElement;
      if (closeTimer) window.clearTimeout(closeTimer);
      show(index, null, { resetZoom: true });
      window.requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function close() {
      lightbox.classList.remove('is-open');
      forgetPage();
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) {
          image.removeAttribute('src');
          resetZoom();
        }
      }, 260);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => open(Number(card.dataset.n)));
    });

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) close();
    });
    closeButton.addEventListener('click', close);
    prevButton.addEventListener('click', () => show(currentIndex - 1, -1));
    nextButton.addEventListener('click', () => show(currentIndex + 1, 1));
    if (zoomInButton) zoomInButton.addEventListener('click', () => setZoom(zoom + 0.25));
    if (zoomOutButton) zoomOutButton.addEventListener('click', () => setZoom(zoom - 0.25));
    if (zoomResetButton) zoomResetButton.addEventListener('click', resetZoom);

    imageWrap.addEventListener('click', (event) => {
      if (event.target.closest('button')) return;
      if (event.target.closest('[data-wc-hotspot]')) {
        // スワイプ・ドラッグ・ピンチの終わりに指が乗っていただけなら、商品ページへは飛ばない。
        // キーボード（Enter）で開くときは detail が 0 なので、そのまま開く
        if (didDrag && event.detail !== 0) {
          event.preventDefault();
          didDrag = false;
        }
        return;
      }
      if (didDrag) {
        didDrag = false;
        return;
      }
      setZoom(zoom > 1 ? 1 : 1.5);
    });

    imageWrap.addEventListener('pointerdown', (event) => {
      activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      // リンクの上で押したときはポインタを奪わない（奪うとクリックがリンクに届かない）
      const onHotspot = Boolean(event.target.closest('[data-wc-hotspot]'));
      if (!onHotspot) imageWrap.setPointerCapture(event.pointerId);
      if (activePointers.size === 1) {
        // 新しい操作の始まり。前の操作（画像の外で指を離した等）の判定を持ち越さない
        didDrag = false;
        pointerStartedOnHotspot = onHotspot;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
      }
      if (activePointers.size >= 2) {
        startPinch();
        return;
      }
      if (zoom <= 1) return;
      isDragging = true;
      didDrag = false;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragPanX = panX;
      dragPanY = panY;
      imageWrap.classList.add('is-dragging');
    });

    imageWrap.addEventListener('pointermove', (event) => {
      if (activePointers.has(event.pointerId)) activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (!isPinching && zoom <= 1 && event.pointerId === swipePointerId) {
        const moveX = Math.abs(event.clientX - swipeStartX);
        const moveY = Math.abs(event.clientY - swipeStartY);
        if (moveX > 8 && moveX > moveY) didDrag = true;
        // リンク上から始まった操作は、縦方向に動いてもリンクのクリックにしない
        if (moveY > 8 && pointerStartedOnHotspot) didDrag = true;
      }
      if (isPinching && activePointers.size >= 2 && pinchStartDistance > 0) {
        const distance = distanceBetweenPointers();
        const center = centerBetweenPointers();
        zoom = clamp(Math.round(pinchStartZoom * (distance / pinchStartDistance) * 100) / 100, 1, 2.5);
        panX = pinchStartPanX + (center.x - pinchCenterX);
        panY = pinchStartPanY + (center.y - pinchCenterY);
        if (zoom === 1) {
          panX = 0;
          panY = 0;
        }
        loadZoomImage();
        applyTransform();
        return;
      }
      if (!isDragging) return;
      if (Math.abs(event.clientX - dragStartX) > 3 || Math.abs(event.clientY - dragStartY) > 3) didDrag = true;
      panX = dragPanX + event.clientX - dragStartX;
      panY = dragPanY + event.clientY - dragStartY;
      applyTransform();
    });

    imageWrap.addEventListener('pointerup', (event) => {
      const swipeDx = event.clientX - swipeStartX;
      const swipeDy = event.clientY - swipeStartY;
      const shouldSwipe =
        !isPinching &&
        !isDragging &&
        zoom <= 1 &&
        event.pointerId === swipePointerId &&
        Math.abs(swipeDx) > 52 &&
        Math.abs(swipeDx) > Math.abs(swipeDy) * 1.25;
      activePointers.delete(event.pointerId);
      if (isPinching && activePointers.size < 2) {
        isPinching = false;
        didDrag = true;
      }
      isDragging = false;
      imageWrap.classList.remove('is-dragging');
      if (imageWrap.hasPointerCapture(event.pointerId)) imageWrap.releasePointerCapture(event.pointerId);
      if (shouldSwipe) {
        didDrag = true;
        show(currentIndex + (swipeDx < 0 ? 1 : -1), swipeDx < 0 ? 1 : -1);
      }
      if (event.pointerId === swipePointerId) swipePointerId = null;
    });

    imageWrap.addEventListener('pointercancel', (event) => {
      activePointers.delete(event.pointerId);
      if (event.pointerId === swipePointerId) swipePointerId = null;
      isPinching = false;
      isDragging = false;
      imageWrap.classList.remove('is-dragging');
    });

    // リンク上で押した指はポインタを奪っていないので、画像の外で離されると上の pointerup が来ない。
    // 記録が残ると次のタップがピンチ扱いになるため、ここで片付ける
    function releaseStrayPointer(event) {
      if (!activePointers.has(event.pointerId)) return;
      activePointers.delete(event.pointerId);
      if (event.pointerId === swipePointerId) swipePointerId = null;
      if (activePointers.size < 2) isPinching = false;
      isDragging = false;
      imageWrap.classList.remove('is-dragging');
    }
    document.addEventListener('pointerup', releaseStrayPointer);
    document.addEventListener('pointercancel', releaseStrayPointer);

    imageWrap.addEventListener('animationend', () => {
      imageWrap.classList.remove('is-turning-next', 'is-turning-prev');
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(currentIndex - 1, -1);
      if (event.key === 'ArrowRight') show(currentIndex + 1, 1);
      if (event.key === '+' || event.key === '=') setZoom(zoom + 0.25);
      if (event.key === '-') setZoom(zoom - 0.25);
      if (event.key === '0') resetZoom();
    });

    // 横長画像が読めない（アップロード漏れ・CDN反映待ち等）ときは、そのページを縦長に戻して開き直す
    image.addEventListener('error', () => {
      const page = pages[currentIndex];
      const src = image.getAttribute('src');
      if (!page || !page.expandedLandscape || (src !== page.expandedLandscape && src !== page.zoomLandscape)) return;
      page.expandedLandscape = '';
      page.zoomLandscape = '';
      show(currentIndex, null, { resetZoom: true });
    });

    // サムネイルも同じ。横長の source を外すと、ブラウザが縦長の画像を選び直す
    cards.forEach((card) => {
      const thumb = card.querySelector('.wc-thumb img');
      const source = card.querySelector('.wc-thumb source');
      if (!thumb || !source) return;
      thumb.addEventListener('error', () => {
        if (!source.isConnected || thumb.currentSrc === thumb.src) return;
        source.remove();
        card.classList.add('is-portrait-fallback');
      });
    });

    // 拡大表示を開いたまま画面幅が変わったら、同じページを縦長／横長の画像で開き直す
    if (landscapeQuery) {
      const onLayoutChange = () => {
        if (lightbox.classList.contains('is-open')) show(currentIndex, null, { resetZoom: true });
      };
      if (landscapeQuery.addEventListener) landscapeQuery.addEventListener('change', onLayoutChange);
      else if (landscapeQuery.addListener) landscapeQuery.addListener(onLayoutChange);
    }

    updateZoomUi();

    // 商品ページから戻ってきたときは、見ていたページを開き直す
    const hashMatch = window.location.hash.match(/^#p-(\d+)$/);
    if (usesHash && hashMatch) open(Number(hashMatch[1]));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-web-catalog-section]').forEach((root, index) => initCatalog(root, index));
  });
})();
